import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const getPredictionsBodySchema = z.object({
  description: z.string().min(1),
  suggestedHsCode: z.string().optional(),
});

export const aiModuleContract = c.router({
  importHistoricalDataset: {
    method: 'POST',
    path: '/ai-module/import-historical-dataset',
    body: c.noBody(),
    responses: {
      201: z.string(),
    },
  },
  getAiData: {
    method: 'POST',
    path: '/ai-module/get-ai-data/:batchId/:declarationId?',
    pathParams: z.object({
      batchId: z.coerce.number(),
      declarationId: z.string().optional(),
    }),
    body: c.noBody(),
    responses: {
      201: z.array(z.any()),
    },
  },
  exportInput: {
    method: 'POST',
    path: '/ai-module/export-input/:batchId/:declarationId?',
    pathParams: z.object({
      batchId: z.string(),
      declarationId: z.string().optional(),
    }),
    body: c.noBody(),
    responses: {
      201: z.any(),
    },
  },
  getPredictionsAiModule: {
    method: 'POST',
    path: '/ai-module/get-predictions-ai-module',
    body: getPredictionsBodySchema,
    responses: {
      201: z.array(z.any()),
    },
  },
  getPredictionsHsCodeClassifier: {
    method: 'POST',
    path: '/ai-module/get-predictions-hs-code-classifier',
    body: getPredictionsBodySchema,
    responses: {
      201: z.array(z.any()),
    },
  },
});
